<section class="section-title">
  <div class="section-title-image">
    <img class="user-image" src="assets/img/group3.png" />
  </div>

  <div class="section-title-text">
    <h1 *ngIf="!groupCreated  && canUserEdit" i18n="@@groupadd_title">Aggiungi gruppo</h1>

    <h1 *ngIf="groupCreated  && canUserEdit" i18n="@@groupadd_title_alt">Modifica gruppo</h1>

    <h1 *ngIf="!canUserEdit" i18n="@@groupadd_title_service">Informazioni gruppo</h1>
  </div>

  <a *ngIf="groupCreated && canUserEdit" (click)="deleteGroup()" class="button button-red" id="deleteGroupButton">
    <ng-container i18n="@@groupadd_delete_user">Elimina gruppo</ng-container>
    <span>
      <fa-icon icon="trash-alt"></fa-icon>
    </span>
  </a>
</section>

<section>

  <form [formGroup]="addGroupForm">
    <table class="simple-table group-add-table">
      <tr>
        <td width="180px" class="text-dark" i18n="@@groupadd_name">Nome</td>

        <ng-container *ngIf="canUserEdit">
          <td><input id="name-input" formControlName="name" [(ngModel)]="groupname" /></td>
        </ng-container>

        <ng-container *ngIf="!canUserEdit">
          <td height="80px">
            <label class="td-label">{{groupname}}</label>
          </td>
        </ng-container>

      </tr>
      <tr>
        <td width="180px" class="text-dark" i18n="@@groupadd_description">Descrizione</td>

        <ng-container *ngIf="canUserEdit">
          <td><input id="name-input" formControlName="description" [(ngModel)]="groupDescription" /></td>
        </ng-container>

        <ng-container *ngIf="!canUserEdit">
          <td height="80px">
            <label class="td-label">{{groupDescription}}</label>
          </td>
        </ng-container>

      </tr>

    </table>

    <div *ngIf=groupCreated>

      <div class="margin-top-30">

        <div class="control-card-white">

          <div class="control-card-header">
            <ng-container i18n="@@groupadd_activated_devices_title">Dispositivi attivati</ng-container>
          </div>

          <div class="control-card-content">

            <mat-tab-group [animationDuration]="'0ms'">

              <mat-tab label={{listString}}>
                <app-add-group-devices-list (onDeviceSelected)="onDeviceSelected($event)"
                  (onDeviceDeselected)="onDeviceDeselected($event)" (selectedDeviceEmitter)="onDeviceSelected($event)"
                  [deviceList]="deviceList" [devicesWithExpiredPermissions]="devicesWithExpiredPermissions" [canUserEdit]="canUserEdit">>
                </app-add-group-devices-list>
              </mat-tab>

              <mat-tab label={{mapString}}>
                <app-add-group-devices-map (onDeviceSelected)="onDeviceSelected($event)"
                  (onDeviceDeselected)="onDeviceDeselected($event)" (selectedDeviceEmitter)="onDeviceSelected($event)"
                  [deviceList]="deviceList" [canUserEdit]="canUserEdit">
                </app-add-group-devices-map>
              </mat-tab>

            </mat-tab-group>

          </div>

        </div>

      </div>
      <div class="margin-top-30">

        <p class="text-small text-error margin-top-10 margin-left-20 display-inline " *ngIf="nameError">
          Devi inserire un nome valido
        </p>

        <a *ngIf="canUserEdit" (click)="creategroup()" class="button group-add-button">
          <ng-container i18n="@@groupadd_save_group">Salva</ng-container>
          <span>
            <fa-icon icon="save"></fa-icon>
          </span>
        </a>

      </div>

    </div>

    <a (click)="creategroup()" id="createGroupButton" class="button group-add-button" *ngIf="!groupCreated && canUserEdit">
      <ng-container i18n="@@groupadd_create_group">Crea Gruppo</ng-container>
      <span>
        <fa-icon icon="save"></fa-icon>
      </span>
    </a>
  </form>
</section>


<app-loading-screen #addgrouploader [loading]="false" [showtext]="false"></app-loading-screen>